import base64 from 'base-64'
import utf8 from 'utf8'

import { type SATInvitationParams, satInvitationParamsSchema } from './types'

export default function decodeInvitationParams(encodedParams: string): SATInvitationParams | null {
  try {
    const decodedParamsBytes = base64.decode(encodedParams)
    const paramsString = utf8.decode(decodedParamsBytes)

    const urlSearchParams = new URLSearchParams(paramsString)

    const paramsObject = Object.fromEntries(urlSearchParams)

    const decodedParams = satInvitationParamsSchema.parse(paramsObject)
    return decodedParams
  } catch (_) {
    return null
  }
}
